<template>
        <!-- Tour Location -->
        <div class="mb-4">
        <label>Latitude</label>
        <input v-model="location.latitude" class="mb-2 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="number" :placeholder="11.59558499056649">
        <label>Longitude</label>
        <input v-model="location.longitude" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="number" :placeholder="50.92270847147885">
        </div>
        <!-- Tour Location -->
</template>

<script>

export default {
    data() {
        return {
            location: {
                latitude: '',
                longitude: ''
            }
        }
    },
    updated() {
        this.$page.props.newTourData.location = this.location;
        this.$page.props.newTourData.selectedProvider = this.$page.props.providers.data.filter(el => el.auth_user_role == 'admin')[0];
    },
}
</script>
